import {
  AdminFonctionnelControllerApi,
  UploadPieceJointeViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { backAlertMessage } from 'hooks/utils/backAlertMessage';
import { ShouldNotHappen } from 'utils/exceptions';

import { Controller, UploadPieceJointeFormValues } from './types';

export async function validateUploadPieceJointe(
  field: UploadPieceJointeViolationDtoFormFieldEnum,
  dossierId: string,
  formValues: UploadPieceJointeFormValues,
  controller: Controller,
): Promise<void> {
  switch (field) {
    case UploadPieceJointeViolationDtoFormFieldEnum.FILE:
      validateRequiredField('Fichier', formValues.file);
      break;
    case UploadPieceJointeViolationDtoFormFieldEnum.TYPE:
      validateRequiredField('Type', formValues.type);
      break;
    default:
      throw new ShouldNotHappen(field);
  }

  // we don't want to call the back OR display an error if one of the required field is still null
  if (formValues.file && formValues.type) {
    return backOfficeValidationHandle(
      controller,
      dossierId,
      field,
      formValues,
    ).catch(error => Promise.reject(String(error)));
  }
}

async function backOfficeValidationHandle(
  controller: Controller,
  dossierId: string,
  field: UploadPieceJointeViolationDtoFormFieldEnum,
  formValues: UploadPieceJointeFormValues,
) {
  const response = await getValidateUploadPieceJointeFieldUsingPOST(controller)(
    dossierId,
    field,
    formValues.type ?? '',
    formValues.file,
  ).catch(async e => {
    if (e instanceof Response) {
      return Promise.reject((await backAlertMessage(e)).description);
    }
    return Promise.reject(String(e));
  });

  const violations = response.uploadPieceJointeViolationDtoList ?? [];

  if (violations.length > 0) {
    throw violations[0].message;
  }
}

function getValidateUploadPieceJointeFieldUsingPOST(controller: Controller) {
  return controller instanceof AdminFonctionnelControllerApi
    ? controller.validateUploadPieceJointeFieldUsingPOST1.bind(controller)
    : controller.validateUploadPieceJointeFieldUsingPOST.bind(controller);
}

function validateRequiredField<T>(fieldName: string, value?: T) {
  if (!value) {
    throw `Le champ ${fieldName} est manquant`;
  }
}
